import { validateUrl, openNewTab, validateWindowSize } from '../../helpers';
import funHereButton from './funHereButton';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function funHereSlideshow() {
  const widgetName = 'funHereSlideshow';
  const widgetOpts = funHereSlideshowOpts;
  const isDesktopScreen = validateWindowSize(1100);

  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      funHereButton();
      $(document).ready(function () {
        setTimeout(() => {
          AOS.init({
            anchorPlacement: 'bottom-bottom',
            animatedClassName: 'aos-animate',
            initClassName: 'aos-init',
          });
        }, 2000);
      });

      $(`#${widgetName}`).html(swiperContainers);
      const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);
      $(`#${widgetName} .arrows`).addClass('slides-' + response.Slides.length);
      $('.fun-container').addClass('slides-' + response.Slides.length);
      response.Slides.forEach(function (slide, x) {
        swiperWidgetWrapper.append(buildSlideTemplate(slide, x, isDesktopScreen));
      });
      initSwiper(widgetName, response.Slides.length);
    } else {
      $('.fun-container').remove();
    }
  });
}

// ------------------------------
// ------------------------------
// Swiper Initialization
function initSwiper(widget, slidesCount) {
  const funSwiper = new Swiper(`#${widget} .swiper-container`, {
    loop: false,
    watchOverflow: true,
    freeMode: false,
    preloadImages: false,
    spaceBetween: 10,
    lazy: {
      loadPrevNext: false,
      loadPrevNextAmount: 1,
    },
    a11y: true,
    grabCursor: true,
    autoHeight: false,
    navigation: {
      nextEl: `#${widget} .swiper-button-next`,
      prevEl: `#${widget} .swiper-button-prev`,
    },
    centeredSlides: false,
    slidesPerView: slidesCount == 4 ? 4 : slidesCount,
    breakpoints: {
      685: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slidesCount > 1,
      },

      980: {
        slidesPerView: slidesCount >= 2 ? 2 : 1,
        loop: slidesCount > 2,
      },

      1245: {
        slidesPerView: Math.min(3, slidesCount),
        loop: slidesCount > 3,
      },
      1300: {
        slidesPerView: slidesCount == 4 ? 4 : slidesCount,
      },
    },
  });

  return funSwiper;
}

// ------------------------------
// aos props
function aosProps(i, desktopOnly) {
  if (desktopOnly) {
    return `
    data-aos="fade-down" 
    data-aos-easing="ease-in-out" 
    data-aos-duration="180" 
    data-aos-delay="${(i + 1) * 150}" 
    data-aos-once="true" 
    data-aos-offset="200"`;
  }
}

// ------------------------------
// Swiper container structure
const swiperContainers = `
    <div class="swiper-button-prev arrows"></div>
      <div class="swiper-container">
          <div class="swiper-wrapper">
          </div>
      </div>
    <div class="swiper-button-next arrows"></div>
  `;

// ------------------------------
// Slide Template
function buildSlideTemplate(slide, x, isDesktop) {
  const { Title, URL, ImageWithPath, ImageAlternateText } = slide;
  const title = `<h3>${Title.slice(0, 40)}</h3>`;

  const template = `
    <div class="swiper-slide" ${aosProps(x, isDesktop)}>
      <div class='swiper-lineup${validateUrl(URL, 'class')}'  ${validateUrl(URL, 'index')}>
        <div class="swiper-content-container">

          <div class="swiper-text-container">
            <div class="title-arrow-container">
              ${title}
              <span class="arrow-icon"></span>
            </div>
            ${URL ? `<a href="${URL}" class="button" ${openNewTab(URL)}>More</a>` : ''}
          </div>

          <div class="swiper-image-container swiper-lazy" style="background-image:url('${ImageWithPath}')" data-background="${ImageWithPath}" aria-label="${ImageAlternateText}"></div>
          <div class="abstract-icon"></div>
          <div class="overlay"></div>
        </div>
      </div>
    </div>
    `;

  return template;
}
